"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlagsmithOptions = exports.FeatureFlagKeys = exports.FF_SLURM = exports.FF_KUBERNETES = exports.FF_COMPUTE = exports.FF_INVOICE_V2 = exports.FF_COST_USAGE_V2 = exports.FF_DATA_SYNC_V2 = exports.FF_API_TOKENS_GA = exports.FF_USER_CONSENT = exports.FF_USER_PROFILE_REAUTH = exports.FF_WORKSPACE_SECRETS_INTEGRATION = exports.FF_USER_WITHDRAWAL = exports.FF_CREDITS = exports.FF_NOTIFICATION_RICH_CONTENT = exports.FF_COMPUTE_ENVIRONMENT = exports.FF_BUCKET_TOKENS_GA = exports.FF_ODC = exports.FF_OBJECT_STORAGE_GA = exports.FF_MODEL_REGISTRY = exports.FF_USER_CACHE = exports.FF_SENTRY_NEXT = exports.FF_DATASYNC_LOG_STREAMER = exports.FF_APPLICATION_LOG_STREAMER = exports.FF_ENDPOINTS = exports.FF_API_TOKENS = exports.FF_QUOTAS = exports.FF_USER_INVITE = void 0;
var env_1 = require("./env");
exports.FF_USER_INVITE = 'ff_user_invite';
exports.FF_QUOTAS = 'ff_quotas';
exports.FF_API_TOKENS = 'ff_api_tokens';
exports.FF_ENDPOINTS = 'ff_endpoints';
exports.FF_APPLICATION_LOG_STREAMER = 'ff_application_log_streamer';
exports.FF_DATASYNC_LOG_STREAMER = 'ff_datasync_log_streamer';
exports.FF_SENTRY_NEXT = 'ff_sentry_next';
exports.FF_USER_CACHE = 'ff_user_cache';
exports.FF_MODEL_REGISTRY = 'ff_model_registry';
exports.FF_OBJECT_STORAGE_GA = 'ff_object_storage_ga';
exports.FF_ODC = 'ff_odc';
exports.FF_BUCKET_TOKENS_GA = 'ff_bucket_tokens_ga';
exports.FF_COMPUTE_ENVIRONMENT = 'ff_compute_environment';
exports.FF_NOTIFICATION_RICH_CONTENT = 'ff_notification_rich_content';
exports.FF_CREDITS = 'ff_credits';
exports.FF_USER_WITHDRAWAL = 'ff_user_withdrawal';
exports.FF_WORKSPACE_SECRETS_INTEGRATION = 'ff_workspace_secrets_integration';
exports.FF_USER_PROFILE_REAUTH = 'ff_user_profile_reauth';
exports.FF_USER_CONSENT = 'ff_user_consent';
exports.FF_API_TOKENS_GA = 'ff_api_tokens_ga';
exports.FF_DATA_SYNC_V2 = 'ff_data_sync_v2';
exports.FF_COST_USAGE_V2 = 'ff_cost_usage_v2';
exports.FF_INVOICE_V2 = 'ff_invoice_v2';
exports.FF_COMPUTE = 'ff_compute';
exports.FF_KUBERNETES = 'ff_kubernetes';
exports.FF_SLURM = 'ff_slurm';
// Attention: insert your ff key here
exports.FeatureFlagKeys = [
    exports.FF_USER_INVITE,
    exports.FF_QUOTAS,
    exports.FF_API_TOKENS,
    exports.FF_ENDPOINTS,
    exports.FF_DATASYNC_LOG_STREAMER,
    exports.FF_SENTRY_NEXT,
    exports.FF_USER_CACHE,
    exports.FF_MODEL_REGISTRY,
    exports.FF_OBJECT_STORAGE_GA,
    exports.FF_ODC,
    exports.FF_BUCKET_TOKENS_GA,
    exports.FF_COMPUTE_ENVIRONMENT,
    exports.FF_NOTIFICATION_RICH_CONTENT,
    exports.FF_CREDITS,
    exports.FF_USER_WITHDRAWAL,
    exports.FF_WORKSPACE_SECRETS_INTEGRATION,
    exports.FF_USER_PROFILE_REAUTH,
    exports.FF_USER_CONSENT,
    exports.FF_API_TOKENS_GA,
    exports.FF_DATA_SYNC_V2,
    exports.FF_COST_USAGE_V2,
    exports.FF_INVOICE_V2,
    exports.FF_COMPUTE,
    exports.FF_KUBERNETES,
    exports.FF_SLURM
];
// Attention: must provide default value
var DEFAULT_FLAGS = {
    ff_user_invite: {
        enabled: false,
        value: ''
    },
    ff_quotas: {
        enabled: false,
        value: {
            showWorkflowTab: false
        }
    },
    ff_api_tokens: {
        enabled: false,
        value: {}
    },
    ff_endpoints: {
        enabled: true,
        value: {
            logs: {
                streamingIdleTimeoutMs: 300000,
                socketConnectMaxRetryCount: 3
            },
            events: {
                streamingIdleTimeoutMs: 300000,
                socketConnectMaxRetryCount: 3
            },
            monitoring: {
                enableV2: true
            },
            chat: {
                showTab: false,
                showContent: true,
                streamingIdleTimeoutMs: 300000,
                socketConnectMaxRetryCount: 3,
                defaultMaxTokens: 2048,
                defaultTemperature: 0.7,
                supportedModels: []
            },
            billing: {
                showInCostUsage: false
            },
            variantAutoScaling: {
                enabled: false
            },
            integrateHFApi: {
                enabled: false
            },
            inferenceEngineConfigUpdate: {
                enabled: true
            }
        }
    },
    ff_datasync_log_streamer: {
        enabled: false,
        value: {
            logStreamingIdleTimeoutMs: 30000,
            maxRetryCount: 3,
            searchEnabled: false
        }
    },
    ff_sentry_next: {
        enabled: false,
        value: {}
    },
    ff_user_cache: {
        enabled: false,
        value: {}
    },
    ff_model_registry: {
        enabled: false,
        value: {}
    },
    ff_data_sync_v2: {
        enabled: false,
        value: {}
    },
    ff_object_storage_ga: {
        enabled: false,
        value: {
            enableMonitoring: false,
            disableStorageMonitor: false,
            disableObjectCountMonitor: false,
            showUploadErrorColumn: false,
            isBucketSearchBarEnabled: false,
            enableDownloadProcess: false,
            uploadConfiguration: {
                maxFileSize: '160GiB',
                clientOptions: {
                    retryMode: 'adaptive',
                    maxAttempts: 3,
                    maxSockets: 50
                },
                uploadOptions: {
                    queueSize: 40,
                    partSizeMap: {
                        '100': 5,
                        '500': 10,
                        '1000': 20
                    },
                    leavePartsOnError: false,
                    maxParts: 10000
                }
            },
            downloadConfiguration: {
                isPresignedUrlDownload: false,
                presignedUrlExpiresInSeconds: 3600,
                enableMultiPartDownload: false,
                multiPartDownloadConfiguration: {
                    chunkSizeThresholds: [
                        { maxFileSizeMb: 1024, chunkSizeMb: 16, concurrency: 10 },
                        { maxFileSizeMb: 5120, chunkSizeMb: 32, concurrency: 8 },
                        { maxFileSizeMb: 10240, chunkSizeMb: 32, concurrency: 8 },
                        { maxFileSizeMb: 20480, chunkSizeMb: 32, concurrency: 8 }
                    ]
                }
            }
        }
    },
    ff_odc: {
        enabled: false,
        value: {
            enableFilterByComputeType: false
        }
    },
    ff_bucket_tokens_ga: {
        enabled: false,
        value: {}
    },
    ff_compute_environment: {
        enabled: false,
        value: {
            enableSidebarInteraction: false,
        }
    },
    ff_notification_rich_content: {
        enabled: false,
        value: {}
    },
    ff_credits: {
        enabled: false,
        value: {}
    },
    ff_user_withdrawal: {
        enabled: false,
        value: {}
    },
    ff_workspace_secrets_integration: {
        enabled: false,
        value: {}
    },
    ff_user_profile_reauth: {
        enabled: false,
        value: {}
    },
    ff_user_consent: {
        enabled: false,
        value: {}
    },
    ff_api_tokens_ga: {
        enabled: false,
        value: {}
    },
    ff_cost_usage_v2: {
        enabled: false,
        value: {}
    },
    ff_invoice_v2: {
        enabled: false,
        value: {}
    },
    ff_compute: {
        enabled: false,
        value: {
            enableVpcSelector: false,
            enableForceDelete: false,
            disableReplaceAction: false,
            enableStorageSelector: false,
            showEventsTab: false
        }
    },
    ff_kubernetes: {
        enabled: false,
        value: {
            resources: {
                enabled: false
            }
        }
    },
    ff_slurm: {
        enabled: true,
        value: {
            partitions: {
                showTab: true
            },
            jobs: {
                showTab: true
            }
        }
    }
};
var getFlagsmithOptions = function () { return ({
    cacheFlags: false,
    defaultFlags: __assign({}, DEFAULT_FLAGS),
    api: env_1.matchConfig.FF_API || '',
    environmentID: env_1.matchConfig.FF_ENVIRONMENT_ID || ''
}); };
exports.getFlagsmithOptions = getFlagsmithOptions;
